import { useGeneralFallbackViewProps } from "src/pages/case-landing/views/general-fallback/general-fallback-view-model";
import { CaseInfoBanner } from "src/components/case-info-banner/case-info-banner";
import { PortalState } from "src/api/types/enums";

const GeneralFallbackView = ({state}: {state: PortalState}) => {
  const { bannerKey } = useGeneralFallbackViewProps(state);
  return <CaseInfoBanner translationKey={`caseInfoBanner.${bannerKey}`} />;
};

export default GeneralFallbackView;
